import * as requestFromServer from '../common/cruds'
import {handleNotificationWithToastify} from '../../../app/services/Functional'
import {callTypes, catchError, endCall, startCall} from '../common/slices'
import {ID} from '../../../_metronic/helpers'

const API_URL = `${process.env.REACT_APP_API_BASE_URL}data-anonymization/`

export const requestAccountDeletion = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}user-request`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't request account deletion"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const handleDataAnonymizationRequest = (id: ID, payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}action/${id}`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't process data anonymization request"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}
